import React, { useEffect, useState } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Avis.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";

const Avis = () => {
  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [total, setTotal] = useState(0);
  const [formData, setFormData] = useState({
    rating: 5,
    comment: "",
  });

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("clientToken") ||
    localStorage.getItem("chauffeurToken");

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      mirror: true,
    });
  }, []);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/reviews`);
      setReviews(res.data.reviews || []);
      setAverageRating(res.data.averageRating || 0);
      setTotal(res.data.total || 0);

      setTimeout(() => {
        AOS.refresh();
      }, 100);
    } catch (error) {
      console.error("Erreur chargement avis :", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) return;

    try {
      await axios.post(`${API_URL}/api/reviews`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setFormData({
        rating: 5,
        comment: "",
      });

      fetchReviews();
    } catch (error) {
      console.error("Erreur ajout avis :", error);
    }
  };

  return (
    <div className="avis-page">
        <div className="avis-inner"></div>
      <div className="avis-header" data-aos="fade-up">
        <h1>AVIS</h1>
        <h3>Découvrez les retours de notre communauté</h3>
      </div>

      <div className="avis-summary" data-aos="fade-up">
        <div className="avis-summary-card">
          <h2>{averageRating}/5</h2>
          <p>Note moyenne</p>
        </div>
        <div className="avis-summary-card">
          <h2>{total}</h2>
          <p>Avis publiés</p>
        </div>
      </div>

      <div className="avis-content">
        <div className="avis-list" data-aos="fade-right">
          {reviews.length > 0 ? (
            reviews.map((review, index) => (
              <div
                key={review._id}
                className="avis-card"
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <div className="avis-card-top">
                  <strong>{review.name}</strong>
                  <span>{'⭐'.repeat(review.rating)}</span>
                </div>
                <p>{review.comment}</p>
              </div>
            ))
          ) : (
            <div className="avis-card">
              <strong>Aucun avis</strong>
              <p>Soyez le premier à laisser un avis.</p>
            </div>
          )}
        </div>

        <div className="avis-form-wrapper" data-aos="fade-left">
          <h2>Laisser un avis</h2>

          {token ? (
            <form onSubmit={handleSubmit} className="avis-form">
              <select
                value={formData.rating}
                onChange={(e) =>
                  setFormData({ ...formData, rating: e.target.value })
                }
              >
                <option value={5}>5 étoiles</option>
                <option value={4}>4 étoiles</option>
                <option value={3}>3 étoiles</option>
                <option value={2}>2 étoiles</option>
                <option value={1}>1 étoile</option>
              </select>

              <textarea
                placeholder="Votre avis..."
                value={formData.comment}
                onChange={(e) =>
                  setFormData({ ...formData, comment: e.target.value })
                }
                required
              />

              <button type="submit">Publier</button>
            </form>
          ) : (
            <div className="avis-login-message">
              Connectez-vous pour laisser un avis.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Avis;